<template>
  <textarea
    class="textarea textarea-bordered w-full focus:ring-2 focus:ring-primary"
    :rows="rows"
    :placeholder="placeholder"
    :value="modelValue"
    @input="onInput"
  />
</template>


<script setup lang="ts">
defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  rows: {
    type: Number,
    default: 3,
  },
});

const emit = defineEmits(["update:modelValue"]);

function onInput(event: Event) {
  const target = event.target as HTMLTextAreaElement;
  emit("update:modelValue", target.value);
}
</script>
